import { render } from "./BabyButton.vue?vue&type=template&id=628796ea"
import script from "./BabyButton.vue?vue&type=script&lang=js"
export * from "./BabyButton.vue?vue&type=script&lang=js"

import "./BabyButton.vue?vue&type=style&index=0&id=628796ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__